import { EEstimationTargets } from '@cian/valuation-main-filters-widget';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useHandleAgentSubmit } from './useHandleAgentSubmit';
import { useHandleDatapaymentSubmit } from './useHandleDatapaymentSubmit';
import { useHandleJKSubmit } from './useHandleJKSubmit';
import { useHandleSuburbanSubmit } from './useHandleSuburbanSubmit';
import { selectFilters } from '../../../selectors/selectFilters';
import { getUser } from '../../../selectors/user';

export const useSubmitClickHandler = () => {
  const { estimationTarget } = useSelector(selectFilters);
  const { isAgent } = useSelector(getUser);
  const handleJKSubmit = useHandleJKSubmit();
  const handleAgentSubmit = useHandleAgentSubmit();
  const handleDatapaymentSubmit = useHandleDatapaymentSubmit();
  const handleSuburbanSubmit = useHandleSuburbanSubmit();
  const isSuburbanTarget = [EEstimationTargets.house, EEstimationTargets.land].includes(estimationTarget);

  return React.useCallback(async () => {
    /**
     * Если пользователь пытается оценить загородку - ведем его на форму расплаты за загородку
     */
    if (isSuburbanTarget) {
      handleSuburbanSubmit();

      return;
    }

    /**
     * Если пользователь пытается оценить ЖК - ведем на страницу оценки ЖК (без формы расплаты)
     */
    if (estimationTarget === EEstimationTargets.newbuilding) {
      handleJKSubmit();

      return;
    }

    /**
     * Если пользователь агент, ведем его сразу в страницу результатов минуя форму расплаты
     */
    if (isAgent) {
      handleAgentSubmit();

      return;
    }

    /**
     * Если пользователь поискун:
     *  проверяем проходил ли он форму расплаты по такому адресу и покажем плашку "перейти к оценки"
     *  если форму расплаты не проходил - ведем на форму расплаты
     */
    handleDatapaymentSubmit();
  }, [
    isSuburbanTarget,
    estimationTarget,
    isAgent,
    handleDatapaymentSubmit,
    handleSuburbanSubmit,
    handleJKSubmit,
    handleAgentSubmit,
  ]);
};
